import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ObservableDataLoader } from '@bsquare/angular-common';
import { Observable } from 'rxjs';
import { createGetLoader } from 'services/observable-data-loader-config';

const BASE_URL = '/api/v1/identity-service';
@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private readonly getLoader: ObservableDataLoader<string[]>;

  public constructor() {
    const httpClient = inject(HttpClient);

    this.getLoader = createGetLoader(httpClient);
  }

  /**
   * Returns all the permissions specified in the identity service.
   */
  public get permissions(): Observable<string[]> {
    return this.getLoader.load(`${BASE_URL}/permissions`);
  }

  /**
   * Returns all the permissions the logged in user has
   */
  public get userPermissions(): Observable<string[]> {
    return this.getLoader.load(`${BASE_URL}/permissions/user`);
  }

  public reloadUserPemissions(): Observable<string[] | undefined> {
    return this.getLoader.reload(`${BASE_URL}/permissions/user`);
  }
}
